import React from 'react';
import { AutocompleteDropdown, Box, Controller, ControllerWrapper, FieldWrapper, FormPreloader, Label, OptionKey, useFormContext } from '@common-fe/common-fe';

import { useRolesList } from '@/modules/role/hooks';
import { IPermissionsSection } from '@/modules/role/role.types';

import RolePermissions from './RolePermissions';

interface Props {
  isEditMode?: boolean;
  isStandAloneMode?: boolean;
  onChangeValues?: (values: OptionKey[]) => void;
}
const SelectRolePermission: React.FC<Props> = ({ isStandAloneMode,onChangeValues, isEditMode}) => {
  const { dropdownOptions, isLoading } = useRolesList({ searchString: '' });
  const {
    control,
    formState: { errors },
  } = useFormContext<IPermissionsSection>();
  
  if(isLoading) {
    return (
      <Box margin={{top: 'l'}}>
        <FormPreloader count={1} />
      </Box>
    );
  }
  return (
    <Box direction='column' margin={{top: 'l'}}>
      <FieldWrapper align="center" margin={{ bottom: '' }}>
        <Label showRequireIcon name="level" isNarrow={true}>
          {isStandAloneMode ?'Role' :'Existing role'}
        </Label>

        <ControllerWrapper>
          <Controller
            name="copyRoleId"
            control={control}
            render={({ field }) => (
              <Box width={{ max: 'medium' }}>
                <AutocompleteDropdown
                  errorText={errors?.copyRoleId?.message}
                  name={field.name}
                  placeholder={isStandAloneMode ? 'Select role' :'Select existing role'}
                  value={field.value} 
                  onChange={(value) => {
                    
                    if(value !== undefined) {
                      field.onChange(value);
                    }
                  }}
                  options={dropdownOptions}
                />
              </Box>
            )}
          />
        </ControllerWrapper>

      </FieldWrapper>
      <RolePermissions isCopyMode onChangeValues={onChangeValues} />
    </Box>

  );
};

export default SelectRolePermission;